// SettingsThemePane.jsx

import React, { useMemo } from 'react';

// Context
import { useUser } from 'context/UserContext';

// Components
import StudioThemeDesigner from 'studio/theme/StudioThemeDesigner';

import './SettingsThemePane.css';

/**
 * SettingsThemePane
 *
 * Hosts the base Theme designer inside Base Settings.
 *
 * @param {object|null} base - Active base model.
 * @returns {ReactNode}
 */
const SettingsThemePane = React.memo(({
  base = null,
}) => {
  const { user } = useUser();

  const baseKey = useMemo(
    () => String(base?.key || '').trim(),
    [base?.key],
  );
  const userKey = useMemo(
    () => String(user?.key || user?.uid || '').trim(),
    [user?.key, user?.uid],
  );

  const themeRef = useMemo(() => (
    baseKey
      ? { source: 'base', baseKey }
      : null
  ), [baseKey]);

  if (!baseKey) {
    return (
      <div className="settings-theme-pane settings-theme-pane-empty">
        Select a base to edit its theme.
      </div>
    );
  }

  return (
    <div className="settings-theme-pane">
      <StudioThemeDesigner
        allowLibraryActions={false}
        themeRef={themeRef}
        userKey={userKey}
      />
    </div>
  );
});

SettingsThemePane.displayName = 'SettingsThemePane';

export default SettingsThemePane;
